import React from "react";
import { filesDownload } from "../../../api/api";
import useDownloads from "../../../hooks/useDownloads";
import { Doc } from "../../../types/db/collections";
import { GetFileResponse } from "../../../types/db/schema/files/file.schema";
import Button from "../buttons/Button";

interface Props {
  file: Doc<GetFileResponse>;
  locked?: boolean;
}

export default function DownloadFileButton(props: Props) {

  const {
    file,
    locked
  } = props;

  const downloadFile = useDownloads();

  return (
    <Button
      size="small"
      icon={locked ? "lock" : "download"}
      disabled={locked}
      onClick={async () => await downloadFile(filesDownload(file._id))}
    >
     
    </Button>
  )
}